/**
 * Global edit-mode flag, shared across the whole app (site nav toggle,
 * Explorer pages) so there's a single "am I editing" concept instead of
 * separate ones per page.
 *
 * The recipe/graph page is the one exception with its own richer state
 * machine (GraphVisualizer's own editMode getter/setter — unsaved-changes
 * confirmation, per-recipe scoping, etc.). It stays the source of truth
 * for itself: main.ts syncs this service *from* GraphVisualizer's
 * onEditModeChanged callback (the actual outcome, which can differ from
 * what was requested if an exit-with-unsaved-changes gets cancelled),
 * rather than the other way around. See main.ts's handleGlobalEditModeToggle().
 */
class EditModeServiceImpl {
  private _editMode: boolean = false;
  private listeners: (() => void)[] = [];

  isEditMode(): boolean {
    return this._editMode;
  }

  setEditMode(value: boolean): void {
    if (this._editMode === value) return;
    this._editMode = value;
    this.notify();
  }

  subscribe(listener: () => void): () => void {
    this.listeners.push(listener);
    return () => {
      const idx = this.listeners.indexOf(listener);
      if (idx >= 0) this.listeners.splice(idx, 1);
    };
  }

  private notify(): void {
    for (const listener of this.listeners) {
      try {
        listener();
      } catch (e) {
        console.error('EditModeService listener error:', e);
      }
    }
  }
}

export const editModeService = new EditModeServiceImpl();
